export default "__VITE_ASSET__D4A1dUmS__"